/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

import * as icons from 'components/icons/brands';

const ProviderValues = ["ai_moderated", "alchemer_redirect", "ballpark_redirect", "custom_link", "custom_link_with_redirect", "facebook", "google", "linkedin", "linkedin_verified", "lookback", "loop11", "lyssna_redirect", "maze_redirect", "microsoft", "no_link", "optimal_redirect", "qualtrics", "snowflake", "sprig", "surveymonkey", "typeform", "user_testing", "user_testing_redirect", "user_zoom", "webex", "zoom"] as const;
export type ProviderValue = typeof ProviderValues[number];

export type BaseProvider = {
  enabled?: boolean,
  hasAPIKey: boolean,
  isAutomated: boolean,
  isConnectable: boolean,
  isDevelopment: boolean,
  isManual: boolean,
  isUnmoderated: boolean,
  key: string,
  name: string,
}

export type Provider = BaseProvider & {
  hasOauth: boolean,
  reconnectable: boolean,
  supportsCustomOauthConfiguration: boolean,
  supportsParticipantTracking: boolean,
  urlPattern: RegExp | null,
  value: ProviderValue,
  isCalendar: boolean,
};

export const RedirectIntegrationProviderValues = ["ai_moderated", "alchemer_redirect", "ballpark_redirect", "custom_link_with_redirect", "lyssna_redirect", "maze_redirect", "optimal_redirect", "user_testing_redirect", "user_zoom"] as const;
export type RedirectIntegrationProviderValue = typeof RedirectIntegrationProviderValues[number];

export type RedirectIntegrationProvider = BaseProvider & {
  displayName: string,
  value: RedirectIntegrationProviderValue,
};

export type IntegrationProviderSubgroup = 'taskRedirect';

export type IntegrationProviders = {
  [key in ProviderValue]: RedirectIntegrationProvider | Provider;
};

export const providers: { [key in ProviderValue]: Provider } = {
  
    ai_moderated: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'AI_MODERATED',
      name: 'AI Moderated',
      reconnectable: false,
      value: 'ai_moderated',
      urlPattern: null,
      isCalendar: false,
    },
  
    alchemer_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'ALCHEMER_REDIRECT',
      name: 'Alchemer',
      reconnectable: false,
      value: 'alchemer_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    ballpark_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'BALLPARK_REDIRECT',
      name: 'Ballpark',
      reconnectable: false,
      value: 'ballpark_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    custom_link: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'CUSTOM_LINK',
      name: 'Custom Link',
      reconnectable: false,
      value: 'custom_link',
      urlPattern: null,
      isCalendar: false,
    },
  
    facebook: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'FACEBOOK',
      name: 'Facebook',
      reconnectable: false,
      value: 'facebook',
      urlPattern: null,
      isCalendar: false,
    },
  
    linkedin: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'LINKEDIN',
      name: 'Linkedin',
      reconnectable: false,
      value: 'linkedin',
      urlPattern: null,
      isCalendar: false,
    },
  
    lookback: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'LOOKBACK',
      name: 'Lookback',
      reconnectable: false,
      value: 'lookback',
      urlPattern: /\S*lookback\.io\/\S+/,
      isCalendar: false,
    },
  
    lyssna_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'LYSSNA_REDIRECT',
      name: 'Lyssna',
      reconnectable: false,
      value: 'lyssna_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    maze_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'MAZE_REDIRECT',
      name: 'Maze',
      reconnectable: false,
      value: 'maze_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    no_link: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'NO_LINK',
      name: 'No Link',
      reconnectable: false,
      value: 'no_link',
      urlPattern: null,
      isCalendar: false,
    },
  
    optimal_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'OPTIMAL_REDIRECT',
      name: 'Optimal',
      reconnectable: false,
      value: 'optimal_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    snowflake: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'SNOWFLAKE',
      name: 'Snowflake',
      reconnectable: false,
      value: 'snowflake',
      urlPattern: null,
      isCalendar: false,
    },
  
    sprig: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: true,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'SPRIG',
      name: 'Sprig',
      reconnectable: false,
      value: 'sprig',
      urlPattern: /a\.sprig\.com\/\w+/,
      isCalendar: false,
    },
  
    qualtrics: {
      hasAPIKey: true,
      hasOauth: true,
      supportsCustomOauthConfiguration: true,
      supportsParticipantTracking: true,
      isAutomated: true,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'QUALTRICS',
      name: 'Qualtrics',
      reconnectable: false,
      value: 'qualtrics',
      urlPattern: /\S+\/jfe\/form\/\w+/,
      isCalendar: false,
    },
  
    surveymonkey: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: true,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'SURVEYMONKEY',
      name: 'SurveyMonkey',
      reconnectable: false,
      value: 'surveymonkey',
      urlPattern: /surveymonkey\.\S+\/r\/\w+/,
      isCalendar: false,
    },
  
    typeform: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: true,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'TYPEFORM',
      name: 'Typeform',
      reconnectable: false,
      value: 'typeform',
      urlPattern: /\w+\.typeform\.com\/\S+/,
      isCalendar: false,
    },
  
    user_testing_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'USER_TESTING_REDIRECT',
      name: 'UserTesting',
      reconnectable: false,
      value: 'user_testing_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    user_testing: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'USER_TESTING',
      name: 'UserTesting',
      reconnectable: false,
      value: 'user_testing',
      urlPattern: null,
      isCalendar: false,
    },
  
    webex: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'WEBEX',
      name: 'Webex',
      reconnectable: false,
      value: 'webex',
      urlPattern: null,
      isCalendar: false,
    },
  
    user_zoom: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'USER_ZOOM',
      name: 'UserZoom',
      reconnectable: false,
      value: 'user_zoom',
      urlPattern: /sourcing\.userzoom\.com/,
      isCalendar: false,
    },
  
    zoom: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'ZOOM',
      name: 'Zoom',
      reconnectable: true,
      value: 'zoom',
      urlPattern: null,
      isCalendar: false,
    },
  
    custom_link_with_redirect: {
      hasAPIKey: false,
      hasOauth: false,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: true,
      isUnmoderated: true,
      key: 'CUSTOM_LINK_WITH_REDIRECT',
      name: 'Tracked custom link',
      reconnectable: false,
      value: 'custom_link_with_redirect',
      urlPattern: null,
      isCalendar: false,
    },
  
    google: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'GOOGLE',
      name: 'Google',
      reconnectable: false,
      value: 'google',
      urlPattern: null,
      isCalendar: true,
    },
  
    loop11: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: true,
      isAutomated: true,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: true,
      key: 'LOOP11',
      name: 'Loop11',
      reconnectable: false,
      value: 'loop11',
      urlPattern: /(\?|&)l11_uid=\d+/,
      isCalendar: false,
    },
  
    linkedin_verified: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: false,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'LINKEDIN_VERIFIED',
      name: 'Linkedin Verified',
      reconnectable: false,
      value: 'linkedin_verified',
      urlPattern: null,
      isCalendar: false,
    },
  
    microsoft: {
      hasAPIKey: false,
      hasOauth: true,
      supportsCustomOauthConfiguration: false,
      supportsParticipantTracking: false,
      isAutomated: false,
      isConnectable: true,
      isDevelopment: false,
      isManual: false,
      isUnmoderated: false,
      key: 'MICROSOFT',
      name: 'Microsoft',
      reconnectable: false,
      value: 'microsoft',
      urlPattern: null,
      isCalendar: true,
    },
  
};


export const allProviders = Object.values(providers).sort(
  (a, b) => {
    if (a.isConnectable && !b.isConnectable) return -1;
    if (!a.isConnectable && b.isConnectable) return 1;

    return a.value.localeCompare(b.value);
  },
).map(x => x.value);

export const automatedProviders = allProviders.filter(x => providers[x].isAutomated);
export const oauthProviders = allProviders.filter(x => providers[x].hasOauth);
export const calendarProviders = allProviders.filter(x => providers[x].isCalendar);

export const unmoderatedProviders = allProviders.filter(
  x => providers[x].isUnmoderated,
);

export const unmoderatedConnectableProviders = unmoderatedProviders.filter(
  x => providers[x].isConnectable
);

export const providerNames = {
  CUSTOM_LINK: 'custom_link',
  CUSTOM_LINK_WITH_REDIRECT: 'custom_link_with_redirect',
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  LINKEDIN: 'linkedin',
  LOOKBACK: 'lookback',
  LOOP11: 'loop11',
  MICROSOFT: 'microsoft',
  NO_LINK: 'no_link',
  QUALTRICS: 'qualtrics',
  SPRIG: 'sprig',
  SURVEYMONKEY: 'surveymonkey',
  TYPEFORM: 'typeform',
  USER_TESTING: 'user_testing',
  USER_ZOOM: 'user_zoom',
  WEBEX: 'webex',
  ZOOM: 'zoom',
}

export const providerIcons = {
  ['ai_moderated']: icons.AiModerated,
  ['alchemer']: icons.Alchemer,
  ['ballpark']: icons.Ballpark,
  ['google']: icons.Google,
  ['lookback']: icons.Lookback,
  ['loop11']: icons.Loop11,
  ['lyssna']: icons.Lyssna,
  ['maze']: icons.Maze,
  ['microsoft']: icons.Microsoft,
  ['optimal']: icons.Optimal,
  ['qualtrics']: icons.Qualtrics,
  ['sprig']: icons.Sprig,
  ['surveymonkey']: icons.Surveymonkey,
  ['typeform']: icons.Typeform,
  ['user_testing']: icons.UserTesting,
  ['usertesting']: icons.UserTesting,
  ['user_zoom']: icons.UserZoom,
  ['webex']: icons.Webex,
  ['zoom']: icons.Zoom,
};

export type ProviderIconKey = keyof typeof providerIcons;

export const activityNames = {
  ['lookback']: 'recording',
  ['qualtrics']: 'survey',
  ['surveymonkey']: 'survey',
  ['typeform']: 'form',
  default: 'task',
};

const CUSTOM_OAUTH_CONFIGURATION_PROVIDERS =
  ["qualtrics"] as const;

export type CustomOAuthConfigurationProvider =
  typeof CUSTOM_OAUTH_CONFIGURATION_PROVIDERS[number];
